function waitFactory(ms) {
  function wait({ path }) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(path ? path.continue() : null), ms)
    })
  }
  wait.displayName = 'wait - ' + ms + 'ms'

  return wait
}

export default waitFactory
